import { actionFactory } from 'redux/factories';
import { types } from './types';

export const getPositions = actionFactory(types.GET_POSITIONS);
export const editPosition = actionFactory(types.EDIT_POSITION);
export const deletePosition = actionFactory(types.DELETE_POSITION);
export const addPosition = actionFactory(types.ADD_POSITION);
export const deletePositionErrors = actionFactory(types.DELETE_POSITION_ERRORS);
